import { render, staticRenderFns } from "./Receta.vue?vue&type=template&id=2864cead"
import script from "./Receta.vue?vue&type=script&lang=js"
export * from "./Receta.vue?vue&type=script&lang=js"
import style0 from "./Receta.vue?vue&type=style&index=0&id=2864cead&prod&lang=scss"
import style1 from "./Receta.vue?vue&type=style&index=1&id=2864cead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports